import { useProject } from '../lib/project-context';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useNavigate } from 'react-router-dom';

/**
 * ModuleHeader — Consistent header for all intelligence modules.
 * Shows: Module title, subtitle, project/scenario selectors.
 */
export function ModuleHeader({ title, subtitle, children }) {
  const { activeProject, activeScenario, projects, scenarios, setActiveProject, setActiveScenario } = useProject();
  const navigate = useNavigate();

  const activeProjects = (projects || []).filter(p => !p.deleted_at);

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-display font-semibold tracking-tight" style={{ color: 'var(--text-primary)' }}>{title}</h1>
      {subtitle && <p className="text-sm mt-1" style={{ color: 'var(--text-muted)' }}>{subtitle}</p>}

      <div className="flex items-center gap-3 mt-4 p-3 rounded-xl" style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-default)' }}>
        <div className="space-y-0.5 min-w-[180px]">
          <span className="text-[9px] font-semibold uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>Proyecto</span>
          <Select value={activeProject?.id || ''} onValueChange={(id) => {
            const p = activeProjects.find(pr => pr.id === id);
            if (p) setActiveProject(p);
          }}>
            <SelectTrigger className="h-9 text-sm"><SelectValue placeholder="Seleccionar proyecto" /></SelectTrigger>
            <SelectContent>
              {activeProjects.map(p => (
                <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {activeProject && (
          <div className="space-y-0.5 min-w-[160px]">
            <span className="text-[9px] font-semibold uppercase tracking-wider" style={{ color: 'var(--text-muted)' }}>Escenario</span>
            <Select value={activeScenario?.id || ''} onValueChange={(id) => {
              const s = (scenarios || []).find(sc => sc.id === id);
              if (s) setActiveScenario(s);
            }}>
              <SelectTrigger className="h-9 text-sm"><SelectValue placeholder="Seleccionar escenario" /></SelectTrigger>
              <SelectContent>
                {(scenarios || []).map(s => (
                  <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {/* Slot for module-specific actions (Editar Inputs, badges, etc.) */}
        {children && <div className="ml-auto flex items-center gap-2">{children}</div>}
      </div>
    </div>
  );
}
